<!-- <div id="ticket1" name="ticket">
  <div class="basket-bottom"></div>
  <div class="header text-center">
    <h5>{{order.createdAt | date: 'dd/MM/yyyy à HH:mm'}}</h5>
    <h4>** {{order.type}} **</h4>
    <h5>Prévue pour {{order.orderProg | date: 'HH:mm' }}</h5>
  </div>
  <hr width="100%" noshade="" size="1">
  <div id="elements">
    <table width="100%">
      <thead>
        <tr>
          <th valign="top">QTE</th>
          <th>PRODUIT</th>
          <th valign="top">PRIX</th>
        </tr>
      </thead>
    </table>
    <table width="100%">
      <tbody *ngFor="let el of elements">
        <tr>
          <td valign="top">{{el.quantity}}</td>
          <td>
            <div>{{el.name}}
              <span *ngIf="el.size!='' && el.level>0">({{el.size}})</span>
            </div>
          </td>
          <td>{{el.price * el.quantity | number : '1.2-2'}} €</td>
        </tr>
        <tr *ngIf="el.optionIngredients?.length>0">
          <td></td>
          <td>
            <span class="ingTitle">Avec :</span>
            <span *ngFor="let opt of el.optionIngredients">{{opt.name}}, </span>
          </td>
          <td>compris</td>
        </tr>
        <tr *ngIf="el.removedCompositions?.length>0">
          <td></td>
          <td>
            <span class="ingTitle">Sans :</span>
            <span *ngFor="let comp of el.removedCompositions">{{comp.name}}, </span>
          </td>
          <td>compris</td>
        </tr>
        <tr *ngFor="let supp of el.supplements">
          <td>{{el.quantity}}</td>
          <td>
            <span class="ingTitle">Supp : {{supp.name}}</span>
          </td>
          <td>{{supp.cout*el.quantity}} €</td>
        </tr>
        <tr>
          <td></td>
          <td>
            {{el.comment}}
          </td>
          <td></td>
        </tr>
      </tbody>
    </table>
    <table *ngFor="let menu of menus" class="table-content">
      <tbody>
        <tr>
          <td valign="top">{{menu.quantity}}</td>
          <td>
            <div>{{menu.title}}</div>
          </td>
          <td>{{menu.price*menu.quantity | number : '1.2-2'}} €</td>
        </tr>
      </tbody>
      <tbody *ngFor="let el of menu?.elements">
        <tr>
          <td valign="top"></td>
          <td>
            <div>{{el.quantity}} {{el.name}}
              <span *ngIf="el.level>0">({{el.size}})</span>
            </div>
          </td>
          <td>{{el.price | number : '1.2-2'}} €</td>
        </tr>
        <tr *ngIf="el.optionIngredients?.length>0">
          <td></td>
          <td>
            <span class="ingTitle">Avec :</span>
            <span *ngFor="let opt of el.optionIngredients">{{opt.name}}, </span>
          </td>
          <td>compris</td>
        </tr>
        <tr *ngIf="el.removedCompositions?.length>0">
          <td></td>
          <td>
            <span class="ingTitle">Sans :</span>
            <span *ngFor="let comp of el.removedCompositions">{{comp.name}}, </span>
          </td>
          <td>compris</td>
        </tr>
        <tr *ngFor="let supp of el.supplements">
          <td></td>
          <td>
            <span class="ingTitle">Supp : {{supp.name}}</span>
          </td>
          <td>{{supp.cout}} €</td>
        </tr>
      </tbody>
      <tbody>
        <tr>
          <td></td>
          <td>
            {{menu.comment}}
          </td>
          <td></td>
        </tr>
      </tbody>
    </table>
    <table style="width: 100%" *ngIf="order.discount>0">
      <tr>
        <td valign="top"></td>
        <td><b>Remise</b></td>
        <td> {{order.discount}} % </td>
        <td> - {{(order.amount*order.discount)/100 }} € </td>
      </tr>
    </table>
  </div>
  <hr width="100%" noshade="" size="1">
  <div class="order-footer">
    <ng-container *ngIf="order.discount==0">
        <h4>Total : {{order.amount | number : '1.2-2' }} € TTC </h4>
        <h5>Total HT : {{ order.amount/1.1 | number : '1.2-2' }} € </h5>
        <h5>TVA 10% : {{ order.amount/11 | number : '1.2-2' }} €</h5>
    </ng-container>
    <ng-container *ngIf="order.discount>0">
        <h4>Total : {{order.amount*(100-order.discount)/100 | number : '1.2-2' }} € TTC </h4>
        <h5>Total HT : {{ order.amount*((100-order.discount)/100)/1.1 | number : '1.2-2' }} € </h5>
        <h5>TVA 10% : {{ order.amount*((100-order.discount)/100)/11 | number : '1.2-2' }} €</h5>
    </ng-container>
    <h5>
      Paiement:
      <span *ngFor="let paymentMode of paymentModes">
        {{paymentMode.label}},
      </span>
    </h5>
  </div>
  <p *ngIf="order.comment!=''">{{order.comment}} </p>
</div> -->

<div #ticket style="padding:10px">
  <div id="printThis">
    <div class="basket-bottom"></div>
    <div id="loadingPage" *ngIf="loading"></div>
    <div *ngIf="ticketContent && !loading" [innerHtml]="ticketContent | safeHtml"></div>
    <hr *ngIf="ticketContent && !loading">
  </div>
  <!-- <div *ngIf="ticketContent && !loading" class="text-center">
    <button class="btn btn-primary" (click)="printTicket()">Imprimer</button>
  </div> -->
</div>